import classNames from 'classnames'
import React from 'react'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IFlowBranchLabelProps = {
  labelX: number
  labelY: number
  label: string
  disabled?: boolean
}

export const FlowBranchLabel = ({ labelX, labelY, label, disabled }: IFlowBranchLabelProps) => (
  <div
    style={{
      position: 'absolute',
      transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
      pointerEvents: 'all',
    }}
    className={classNames(styles.branchLabel, { [styles.disabled]: disabled })}
  >
    <Typography
      ariaLabel={'branchLabel'}
      ellipsis
      tooltipProps={{
        label,
      }}
    >
      {label}
    </Typography>
  </div>
)
